import React from 'react';
function VisaLogo() {
  return <svg viewBox="0 0 48 16" className="h-[18px] md:h-5 w-auto" aria-label="Visa" data-id="element-220">
      <text x="2" y="13" fill="#FFFFFF" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="15" data-id="element-221">
        VISA
      </text>
    </svg>;
}
function MastercardLogo() {
  return <svg viewBox="0 0 38 24" className="h-[18px] md:h-5 w-auto" aria-label="Mastercard" data-id="element-222">
      <circle cx="13" cy="12" r="9" fill="#EB001B" data-id="element-223" />
      <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-224" />
      <path d="M19 5.3a9 9 0 0 1 0 13.4 9 9 0 0 1 0-13.4z" fill="#FF5F00" data-id="element-225" />
    </svg>;
}
function AmexLogo() {
  return <svg viewBox="0 0 40 16" className="h-[18px] md:h-5 w-auto" aria-label="American Express" data-id="element-226">
      <rect width="40" height="16" rx="2" fill="#1F72CF" data-id="element-227" />
      <text x="20" y="11.5" fill="#fff" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="7" textAnchor="middle" data-id="element-228">
        AMEX
      </text>
    </svg>;
}
function PayPalLogo() {
  return <svg viewBox="0 0 44 16" className="h-[18px] md:h-5 w-auto" aria-label="PayPal" data-id="element-229">
      <text x="2" y="12.5" fill="#5B9DD9" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="11" data-id="element-230">
        Pay
      </text>
      <text x="22" y="12.5" fill="#A6D4F0" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="11" data-id="element-231">
        Pal
      </text>
    </svg>;
}
function ApplePayLogo() {
  return <svg viewBox="0 0 44 16" className="h-[18px] md:h-5 w-auto" aria-label="Apple Pay" data-id="element-232">
      <path d="M8.2 3.8c-.5.6-1.3 1-2 1-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.5-.7 2.1zm.7 1.1c-1.1-.1-2.1.6-2.6.6s-1.4-.6-2.3-.6C2.5 4.9 1 6.2 1 8.7c0 1.6.6 3.2 1.4 4.3.7 1 1.3 1.8 2.2 1.8s1.2-.6 2.3-.6 1.4.6 2.3.6 1.4-.8 2-1.7c.4-.5.7-1.1.9-1.7-1.2-.5-2-1.6-2-2.9 0-1.2.6-2.2 1.6-2.8-.6-.8-1.5-1.3-2.5-1.4l-.3.1z" fill="#FFFFFF" data-id="element-233" />
      <text x="16" y="12" fill="#FFFFFF" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="9" data-id="element-234">
        Pay
      </text>
    </svg>;
}
function GPayLogo() {
  return <svg viewBox="0 0 38 16" className="h-[18px] md:h-5 w-auto" aria-label="Google Pay" data-id="element-235">
      <text x="1" y="12.5" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" data-id="element-236">
        <tspan fill="#4285F4" data-id="element-237">G</tspan>
      </text>
      <text x="11" y="12.5" fill="#BFC4CB" fontFamily="Arial, sans-serif" fontWeight="500" fontSize="9.5" data-id="element-238">
        Pay
      </text>
    </svg>;
}
export function TrustBadges() {
  return <div className="w-full max-w-full flex flex-col items-center gap-1.5 md:gap-2.5 mt-2 md:mt-4 px-4" data-id="element-239">
      {/* Payment Icons Row — naked logos on dark, wraps on narrow screens */}
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 max-w-full" data-id="element-240">
        <VisaLogo data-id="element-241" />
        <MastercardLogo data-id="element-242" />
        <AmexLogo data-id="element-243" />
        <PayPalLogo data-id="element-244" />
        <ApplePayLogo data-id="element-245" />
        <GPayLogo data-id="element-246" />
      </div>

      {/* SSL Security — thin outline lock, minimal text */}
      <div className="flex items-center gap-1.5 text-[#6a6a5a] text-[10px] tracking-wide font-['Lato'] text-center" data-id="element-247">
        <svg viewBox="0 0 16 16" className="w-3 h-3 flex-shrink-0" fill="none" stroke="#5a9a5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-248">
          <rect x="3" y="7" width="10" height="7" rx="1.5" data-id="element-249" />
          <path d="M5 7V5a3 3 0 0 1 6 0v2" data-id="element-250" />
        </svg>
        <span data-id="element-251">Encriptación SSL 256 bits · Seguridad de Grado Bancario</span>
      </div>

      {/* Delivery */}
      <p className="text-[#7a7a6a] text-[10px] font-['Lato'] tracking-wide text-center" data-id="element-252">
        🚀 Entrega automática al email tras completar el pago
      </p>
    </div>;
}